import { graphql } from '@/gql';
import type { GetItemDetailsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getItemDetails = async ({ item, optionsCursor }: GetItemDetailsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query getItemDetails($item: StoreItemInput!, $optionsCursor: String) {
        getItemDetails(item: $item, optionsCursor: $optionsCursor) {
          item {
            id
            storeId
            storeTitle
            title
            subtitle
            service
            price
            quantity
            currency
            serviceItemReference
            substitutionPreference
            isSpecialInstructionsDisabled
          }
          options {
            ...OptionsFields
            values {
              ...ValuesFields
              subOptions {
                ...OptionsFields
                values {
                  ...ValuesFields
                  subOptions {
                    ...OptionsFields
                    values {
                      ...ValuesFields
                      subOptions {
                        ...OptionsFields
                        values {
                          ...ValuesFields
                          subOptions {
                            ...OptionsFields
                            values {
                              ...ValuesFields
                              subOptions {
                                ...OptionsFields
                                values {
                                  ...ValuesFields
                                  subOptions {
                                    ...OptionsFields
                                    values {
                                      ...ValuesFields
                                      subOptions {
                                        ...OptionsFields
                                        values {
                                          ...ValuesFields
                                          subOptions {
                                            ...OptionsFields
                                            values {
                                              ...ValuesFields
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `),
    variables: {
      item,
      optionsCursor,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getItemDetails;
};
